module.exports = __webpack_public_path__ + "img/img5-3.1bbc45f4.png";